<template>
    <div class="warpper">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" class="input-form">
            <div class="flex align-center justify-between">
                <h3 class="page-title line-height">分支机构基本信息</h3>
                <el-button class="blue-btn" round type="primary" @click="$router.go(-1)">返回</el-button>
            </div>
            <el-form-item ref="morglogo" class="form-row-item flex align-center margin-tb-sm" label="单位LOGO"
                          prop="morglogo">
                <el-upload
                    :action="`${ONLINEHOST_EMOF}home/User/imgthumb`"
                    :data="fileData"
                    :name="'image'"
                    :on-success="handleAvatarSuccess"
                    :show-file-list="false"
                    accept="image/*"
                    class="avatar-uploader margin-left"
                >
                    <div class="flex align-center">
                        <el-image v-if="ruleForm.morglogo" :src="ruleForm.morglogo" class="logo "></el-image>
                        <div v-else class="logo up">点击上传</div>
                        <div slot="tip" class="el-upload__tip margin-left">推荐尺寸大小120px*120px,5M以内</div>
                    </div>
                </el-upload>
            </el-form-item>

            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item ref="morgname" class="input-container" label="分支机构名称" labelWidth="100px"
                                  prop="morgname">
                        <el-input v-model="ruleForm.morgname" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item ref="rankId" class="input-container" label="分支机构等级" labelWidth="100px" prop="rankId">
                        <el-select v-model="ruleForm.rankId" placeholder="请选择分支机构等级">
                            <el-option
                                v-for="item in levelList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item ref="contacts" class="input-container" label="联系人" labelWidth="100px" prop="contacts">
                        <el-input v-model="ruleForm.contacts" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item ref="morgtel" class="input-container" label="联系电话" labelWidth="100px" prop="morgtel">
                        <el-input v-model="ruleForm.morgtel" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <el-form-item ref="address" class="input-container" label="地址" labelWidth="100px" prop="address">
                        <el-input v-model="ruleForm.address" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item ref="morgemail" class="input-container" label="邮箱" labelWidth="100px"
                                  prop="morgemail">
                        <el-input v-model="ruleForm.morgemail" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item ref="morgurl" class="input-container" label="网址" labelWidth="100px" prop="morgurl">
                        <el-input v-model="ruleForm.morgurl" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20" v-if="false">
                <el-col :span="12">
                    <el-form-item ref="pinshu_code" class="input-container" label="分支机构聘书编号" labelWidth="100px"
                                  prop="pinshu_code">
                        <el-input v-model="ruleForm.pinshu_code" placeholder="请输入分支机构聘书编号"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="page-title margin-tb-sm">分支机构介绍</div>

            <el-form-item ref="morgdesc" class="margin-bottom-sm" label="分支机构介绍" labelWidth="90px" prop="morgdesc">
                <div class="input-container padding-xs">

                    <VueUditorWrap v-model="ruleForm.morgdesc" :config="myConfig"></VueUditorWrap>
                </div>
            </el-form-item>

            <div class="flex align-center justify-center margin-tb">
                <el-button :loading="loading" class="blue-btn big-btn" type="primary"
                           @click="submitForm('ruleForm',1)">修改保存
                </el-button>
                <el-button :loading="loading" class="blue-btn big-btn" type="primary"
                           @click="saveForm2('ruleForm',1)">通过
                </el-button>
                <el-button :loading="loading" class="line-btn big-btn" type="primary"
                           @click="saveForm2('ruleForm',2)">拒绝
                </el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
import VueUditorWrap from 'vue-ueditor-wrap'
import {bdEditConfig} from "@/utils/utils"
import rules from "@/utils/rules";
import {fhCheck, getApplyUserDataFh, setApplyUserFh,getRankList} from '@/api/organiz'
// import {baseURL} from "@/config";
import {img_url} from "@/utils/const";
import {ONLINEHOST_EMOF} from "@/config";

export default {
    morgname: "info",
    data() {
        return {
            ONLINEHOST_EMOF:ONLINEHOST_EMOF,
            myConfig: bdEditConfig(),
            baseURL: img_url,
            id: '',
            ruleForm: {
                morglogo: '',
                morgname: '',
                rankId: '',
                contacts: '',
                morgtel: '',
                address: '',
                morgemail: '',
                morgurl: '',
                pinshu_code: '',
                morgdesc: '',
            },
            rules: {
                // morglogo: [{required: true, message: "请上传单位LOGO", trigger: "change"}],
                morgname: [
                    {required: true, message: '请输入分支机构名称', trigger: 'blur'}
                ],
                rankId: [{required: true, message: "请选择分支机构等级", trigger: "change"}],
                contacts: [
                    {required: true, message: '请输入联系人', trigger: 'blur'}
                ],
                morgtel: rules.tel,
                // address: [
                //     {required: true, message: '请输入地址', trigger: 'blur'}
                // ],
                morgemail: [
                    // {required: true, message: '请输入邮箱地址', trigger: 'blur'},
                    {type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur'}
                ],
                morgurl: [
                    rules.webUrl
                ],
                // morgurl: [
                //   {required: true, message: '请输入网址', trigger: 'blur'}
                // ],
                // morgdesc: [
                //   {required: true, message: '请输入分支机构介绍', trigger: 'blur'}
                // ],

            },
            loading: false
        }
    },
    computed: {
        fileData() {
            return {
                mid: this.$store.state.user.emofUserTokenSafer
            }
        }
    },
    created() {
        this.$emit('setIndex', [3, 3], '分支机构编辑')
        this.id = this.$route.params.id || ''
        this.getRankList()
        if (Number(this.id)) this.init()
    },
    components: {VueUditorWrap},
    methods: {
        //  审核判断
        saveForm2(formName, state) {
            this.$refs[formName].clearValidate()
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (state === 1) {
                        this.passInfo()
                    } else {
                        this.refuseInfo()
                    }
                } else {
                    this.$message.error('信息填写有误，请确认！')
                }
            });

        },
        //  通过
        async passInfo() {
            let _state = await fhCheck(this.$route.params.id, 1, '')
            if (_state.status === 200) {
                this.$message.success('操作成功')
                this.$router.go(-1)
            }
        },
        //  拒绝
        refuseInfo() {
            this.$prompt('请输入拒绝原因', '拒绝原因', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(({value}) => {
                if (!value) return this.$message.error('请输入拒绝原因')
                this.sureRefuse(value)
            })
        },
        async sureRefuse(str) {
            let _state = await fhCheck(this.$route.params.id, 2, str)
            if (_state.status === 200) {
                this.$message.success('操作成功')
                this.$router.go(-1)
            }
        },
        async init() {
            let _data = await getApplyUserDataFh(this.id)
            if (_data.status === 200) {
                this.ruleForm = {
                    morglogo: _data.data.logo,
                    morgname: _data.data.name,
                    rankId: _data.data.rank_id || '',
                    contacts: _data.data.lianxiren,
                    morgtel: _data.data.lianxidianhua,
                    address: _data.data.addresss,
                    morgemail: _data.data.email,
                    morgurl: _data.data.website,
                    pinshu_code: _data.data.pinshu_code,
                    morgdesc: _data.data.desc,
                }
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid, validates) => {
                if (valid) {
                    this.submitChange();
                } else {
                    let error = Object.values(validates).shift().shift()
                    let dom = this.$refs[error.field]
                    this.$confirm(error.message, "提示", {
                        confirmButtonText: "确定",
                        showCancelButton: false,
                        type: "warning",
                    }).then(() => {
                        dom.$el.scrollIntoView({
                            block: 'center', // 当前元素显示在视图区域中间
                            behavior: 'auto' // 滚动速度
                        })
                    })
                }
            });
        },
        async submitChange() {
            this.loading = true
            let _data = await setApplyUserFh(this.id, this.ruleForm.morglogo, this.ruleForm.morgname,
                this.ruleForm.rankId,this.ruleForm.contacts, this.ruleForm.morgtel, this.ruleForm.address,
                this.ruleForm.morgemail, this.ruleForm.morgurl, this.ruleForm.morgdesc,this.ruleForm.pinshu_code)
            this.loading = false
            if (_data.status === 200) {
                this.$message.success('提交成功')
                this.$router.go(-1)
            }
        },
        //  获取等级列表
        async getRankList() {
            let _list = await getRankList(2)
            this.levelList = _list.data
        },
        handleAvatarSuccess(res) {
            if (res.status === 200) {
                this.ruleForm.morglogo = res.data
            } else {
                this.$message.error(res.msg)
            }
        },
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.warpper {
    background-color: #ffffff;
    border-radius: 10px;
    padding: 20px 30px;

    .el-select {
        width: 100%;
    }

    .logo {
        width: 80px;
        height: 80px;
        border-radius: 80px;

        &:hover {
            border: 1px dotted #fc7802;
        }

        &.up {
            border: 1px dotted #999999;
            line-height: 80px;
            text-align: center;
        }
    }

    .morgdesc {
        border-radius: 10px;
        border: solid 1px #dae0e6;
        padding: 12px;
    }

    .input-form-btn {
        width: 200px;
        height: 40px;
        line-height: 40px;
        border-radius: 40px;
        font-size: 16px;
        background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
        linear-gradient(#ff9600, #ff9600);
        background-blend-mode: normal, normal;
        color: #ffffff;
        margin-top: 20px;
        padding: 0;

        &.white {
            background: #ffffff none;
            color: #ff9600;
        }
    }
}

.page-title {
    span {
        font-size: 14px;
        font-weight: normal;
    }
}
</style>
